import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack, TextField, MenuItem, FormControlLabel, Checkbox, Divider } from "@material-ui/core";
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack5';
import apiSms from '../../../../src/api/sms';

export default function DialogSendMessage({ contact, isOpenModalSend, handleCloseModalSend }) {
    console.log(contact);
    const [listTemplate, setListTemplate] = useState(['']);
    const [contentTempSms, setContentTempSms] = useState('');
    const [getIdTemp, setGetIdTemp] = useState('');
    const [contentTempZns, setContentTempZns] = useState('');
    const [typeSendOption, setTypeSendOption] = useState('sms');
    const [checkForward, setCheckForward] = useState(false);
    const [listBrandnameSms, setListBrandnameSms] = useState(['']);
    const [dynamicFields, setDynamicFields] = useState([]);
    const checkbox = useRef();
    const [brandName, setBrandName] = useState('');
    const [paramsSend, setParamsSend] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const type_send = [
        { label: 'SMS', code: 'sms' },
        { label: 'ZNS', code: 'zns' },
    ];
    const getTemplate = async (type_send) => {
        const res = await apiSms.find_temp({ "type_send": type_send, "categories_type": 'CSKH', "verify_type": 1 });
        if (res.data?.data.status == 1000) {
            setListTemplate(res.data.data.data);

        } else {
            enqueueSnackbar(res.data.data.message, { variant: 'error' });
        }
    }
    const getContentTemplate = async (type_send, template_id) => {
        const res = await apiSms.findone_temp({ "template_id": template_id });
        if (res.status == 200) {
            if (type_send == "sms") {
                setContentTempSms(res.data.data.data.messages);
                setGetIdTemp(res.data.data.data.id);
                setDynamicFields(res.data.data.matches);
            } else {
                setContentTempZns(res.data.data.data.messages);
            }
        } else {
            enqueueSnackbar("Lấy nội dung mẫu tin thất bại!!!", { variant: 'error' });
        }
    }

    const getBrandname = async (type_send) => {
        try {
            const res = await apiSms.get_brandname({ "type_send": type_send });
            if (res.status == 200) {
                setListBrandnameSms(res.data.data);
            }
        } catch (error) {
            enqueueSnackbar("Tìm tên thương hiệu lỗi!!!", { variant: 'error' });
        }
    }

    const onChangeTypeSend = (value) => {
        if (value == 'zns') {
            setTypeSendOption(value);
            setCheckForward(false);
        } else {
            setTypeSendOption(value);
            setCheckForward(false);
        }
        getTemplate(value);
    };

    const clickToChecked = (e) => {
        if (e.target.checked) {
            getBrandname("sms");
            setCheckForward(true);
        } else {
            setCheckForward(false);
        }
    };
    const sendMessage = async () => {
        try {
            paramsSend['phone'] = contact.phone;
            const res = await apiSms.quick_send_messages({ "brandname": brandName, "typeSend": typeSendOption, "CampaignID": contact.name, "TemplateID": getIdTemp, "raw": paramsSend });
            if (res.status == 200) {
                enqueueSnackbar(res.data.message[0], { variant: 'success' });
                handleCloseModalSend();
            }
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    }

    return (
        <>
            <Dialog open={isOpenModalSend} onClose={handleCloseModalSend} fullWidth>
                {/* <DialogTitle>Gửi tin nhắn cho {contact.name}</DialogTitle> */}
                <DialogTitle>
                    <Typography sx={{ color: '#303187', fontSize: '20px', fontWeight: 700 }}>{"Gửi tin nhắn cho " + contact.name}</Typography>
                </DialogTitle>
                <Divider sx={{ mt: '20px' }} />
                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 3 }}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                                name='type_send'
                                id='type_send'
                                fullWidth
                                select
                                label="Kiểu gửi"
                                onChange={(e) => {
                                    if (e && e.target && e.target.value) {
                                        onChangeTypeSend(e.target.value);
                                    }
                                }}
                            // {formik.setFieldValue('sms_selectTypeSend_sms', "sms")}
                            // {...formik.getFieldProps('sms_selectTypeSend_sms')}
                            >
                                {type_send.map((item) => (
                                    <MenuItem key={item.code} value={item.code}>
                                        {item.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <TextField
                                sx={{ mt: 2 }}
                                name='template'
                                id='template'
                                select
                                fullWidth
                                label="Mẫu tin"
                                onChange={(e) => {
                                    if (e && e.target && e.target.value) {
                                        getContentTemplate("sms", e.target.value);
                                    }
                                }}
                            >
                                {listTemplate.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                                id="content_template"
                                multiline
                                fullWidth
                                rows={3}
                                defaultValue={contentTempSms}
                                disabled
                            />
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            {dynamicFields && dynamicFields.map((fields, index) => (
                                <TextField
                                    key={index}
                                    fullWidth
                                    label={fields}
                                    required
                                    name={fields}
                                    onChange={(e) => setParamsSend({ ...paramsSend, [fields]: e.target.value })}
                                />
                            ))}
                        </Stack>
                        {typeSendOption == "zns" ? <FormControlLabel
                            control={<Checkbox onClick={(e) => clickToChecked(e)} ref={checkbox} />}
                            label="Chuyển tiếp SMS"
                        /> : null}
                        {checkForward ? <Stack sx={{ mt: 2 }} direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <TextField
                                name='brand_name'
                                id='brand_name'
                                select
                                fullWidth
                                label="Tên thương hiệu"
                                onChange={(e) => {
                                    if (e && e.target && e.target.value) {
                                        setBrandName(e.target.value);
                                    }
                                }}
                            >
                                {listBrandnameSms.map((item) => (
                                    <MenuItem key={item} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Stack> : null}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={handleCloseModalSend} startIcon={<Icon icon="ph:x-bold" />} color="primary">
                        Đóng
                    </Button>
                    <Button startIcon={<Icon icon="mdi:email-send-outline" />} variant="contained" onClick={sendMessage} color="primary">
                        Gửi
                    </Button>
                </DialogActions>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
                    <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 93% 0, 100% 100%, 0 100%)' }}> </Box>
                </Box>
            </Dialog>

        </>
    );
}
